'use strict';

var React = require('react');

var SvgAddCodeMajor = function SvgAddCodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 9c0 .266-.105.52-.293.707l-.293.293.293.293a.996.996 0 0 1 .293.707v4a1 1 0 0 0 1 1 1 1 0 0 1 0 2c-1.654 0-3-1.346-3-3v-3.586l-.707-.707a1 1 0 0 1 0-1.414l.707-.707v-3.586c0-1.654 1.346-3 3-3a1 1 0 0 1 0 2 1 1 0 0 0-1 1v4zm16.707.293a1.001 1.001 0 0 1 0 1.414l-.707.707v3.586c0 1.654-1.346 3-3 3a1 1 0 1 1 0-2 1 1 0 0 0 1-1v-4c0-.266.105-.52.293-.707l.293-.293-.293-.293a.996.996 0 0 1-.293-.707v-4a1 1 0 0 0-1-1 1 1 0 1 1 0-2c1.654 0 3 1.346 3 3v3.586l.707.707zm-6.707-.293a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0v-2h-2a1 1 0 0 1 0-2h2v-2a1 1 0 1 1 2 0v2h2z"
  }));
};

exports.SvgAddCodeMajor = SvgAddCodeMajor;
